module.exports = __webpack_public_path__ + "img/emo_04.e5b26505.png";